export const constants = {
    _window: window,
    _document: document,
    $window: $(window),
    mainWrap: document.querySelector("html"),
    $body: $("body"),
    isTouch: "ontouchstart" in window ? function () {document.body.classList.add("touch"); return true;}() : function () {document.body.classList.add("no-touch"); return false;}(),
};

export function detectDevicesAndBrowser() {

    isTouch();
    isSafari();

    function isTouch() {
        return "ontouchstart" in window ? constants.$body.addClass("touch") : constants.$body.addClass("no-touch");
    }

    function isSafari() {
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            constants.$body.addClass("safari");
        }
    }

    constants.$window.on("load", () => {
        constants.$body.addClass("load");
    });
};

export const bodyLock = {
    parentElements: $("html, body"),
    mainContainer: $(".main"),
    windowWidth: window.innerWidth,
    scrollTop: 0,

    lockBody: function () {
        if (window.pageYOffset) {
            this.scrollTop = window.pageYOffset;
            this.mainContainer.css({
                top: -(this.scrollTop)
            });
        }
        this.parentElements.css({
            maxHeight: "100vh",
            overflow: "hidden"
        });
    },

    unlockBody: function () {
        this.parentElements.css({
            maxHeight: "",
            overflow: ""
        });
        this.mainContainer.css({
            top: ""
        });
        window.scrollTo(0, this.scrollTop);
        window.setTimeout(function () {
            bodyLock.scrollTop = null;
        }, 0);
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/module.js